import React, { useState } from "react";
import { FaChevronDown, FaChevronUp, FaQuestion } from "react-icons/fa6";
import { TbMessages } from "react-icons/tb";
import InputField from "../inputField/InputField";
import CustomSelector from "../selector/CustomSelector";

const items = [
  {
    key: "1",
    label: "How does Credit Repair work?",
    content: (
      <p>
        Credit repair works by challenging and removing negative items that
        violate FCRA laws through expertly crafted dispute letters sent to
        credit bureaus, creditors, and secondary agencies. Our meticulous
        process is designed to improve your credit score by ensuring your report
        is accurate and free from unjustified negative entries.
      </p>
    ),
  },
  {
    key: "2",
    label: "Why do I need Credit Monitoring?",
    content: (
      <p>
        Credit monitoring is essential because it provides real-time updates on
        changes to your credit report, helping you quickly spot and address
        potential issues. We use this data to import into our credit repair
        software, allowing us to efficiently track and manage your credit repair
        progress.
      </p>
    ),
  },
  {
    key: "3",
    label: "How long will it take to fix my credit?",
    content: (
      <p>
        The time it takes to fix your credit can vary depending on the
        complexity of your credit issues and the responsiveness of the credit
        bureaus. Generally, you can start seeing improvements within a few days
        to months as we systematically address and resolve negative items.
      </p>
    ),
  },
];

const CustomCollapse = ({ items }) => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleItem = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <div className="custom-collapse">
      {items.map((item) => (
        <div key={item.key} className="collapse-item">
          <button
            className="collapse-header"
            onClick={() => toggleItem(item.key)}
          >
            <span>{item.label}</span>
            {activeKey === item.key ? (
              <FaChevronUp className="ml-2" />
            ) : (
              <FaChevronDown className="ml-2" />
            )}
          </button>
          {activeKey === item.key && (
            <div className="collapse-content px-4 py-2">{item.content}</div>
          )}
        </div>
      ))}
    </div>
  );
};

function Support() {
  const [activeStep, setActiveStep] = useState(1);
  const [name, setName] = useState("");
  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const options = [
    { value: "24h", label: "24 Hours" },
    { value: "7d", label: "7 Days" },
    { value: "30d", label: "30 Days" },
    { value: "1y", label: "1 Year" },
    { value: "all", label: "All Time" },
  ];

  return (
    <div className="my_account general">
      <div className="tabs_area">
        <div className="steps">
          <button
            className={`step ${activeStep === 1 ? "active" : ""}`}
            onClick={() => setActiveStep(1)}
            aria-label="Step 1: Documents"
          >
            <FaQuestion className="icons" /> FAQs
          </button>
          <button
            className={`step ${activeStep === 2 ? "active" : ""}`}
            onClick={() => setActiveStep(2)}
            aria-label="Step 2: Refer a Friend"
          >
            <TbMessages className="icons" /> Help Center
          </button>
        </div>
        <div className="step-container">
          <div className="step-content">
            {activeStep === 1 && (
              <div className="tabs_card">
                <div className="header">
                  <h4>FAQs</h4>
                </div>
                <div className="content">
                  <CustomCollapse items={items} />
                </div>
              </div>
            )}
            {activeStep === 2 && (
              <div className="tabs_card">
                <div className="content refer_content">
                  <div className="text-center">
                    <h1>We're here to help!</h1>
                    <p className="mt-2">
                      Don't hesitate to reach out for any questions, concerns,
                      or any problems you ran into.
                    </p>
                    <p className="mt-2">(Response usually within 12-24hrs)</p>
                  </div>
                  <form className="input_group">
                    <div className="selector">
                      <label>Select issue type</label>
                      <CustomSelector
                        options={options}
                        onSelect={(option) => console.log(option)}
                      />
                    </div>
                    <InputField
                      label="Email"
                      value={name}
                      onChange={handleNameChange}
                    />
                    <textarea
                      className="textarea"
                      placeholder="Write your issue"
                    />
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
